import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'

// 頁面組件 (延遲載入)
const Home = () => import('@/views/Home.vue')
const NotFound = () => import('@/views/NotFound.vue')

// 營養指南頁面
const NutritionIndex = () => import('@/views/Nutrition/NutritionIndex.vue')
const MediterraneanDietGuide = () => import('@/views/Nutrition/MediterraneanDietGuide.vue')
const HealthyFatsRecipes = () => import('@/views/Nutrition/HealthyFatsRecipes.vue')

// 食譜頁面
const RecipesIndex = () => import('@/views/Recipes/RecipesIndex.vue')
const MainRecipes = () => import('@/views/Recipes/MainRecipes.vue')
const OldwaysRecipes = () => import('@/views/Recipes/OldwaysRecipes.vue')
const RecipeDetail = () => import('@/views/Recipes/RecipeDetail.vue')

// 健康資訊頁面
const HealthIndex = () => import('@/views/Health/HealthIndex.vue')
const Sleep = () => import('@/views/Health/Sleep.vue')
const SleepSurvey = () => import('@/views/Health/SleepSurvey.vue')
const HealthyMeetings = () => import('@/views/Health/HealthyMeetings.vue')
const STOPP = () => import('@/views/Health/STOPP.vue')

// 研究文章頁面
const ResearchIndex = () => import('@/views/Research/ResearchIndex.vue')
const HarvardStudies = () => import('@/views/Research/HarvardStudies.vue')
const HarvardDietQuality = () => import('@/views/Research/HarvardDietQuality.vue')
const HdlFunctionMedDiet = () => import('@/views/Research/HdlFunctionMedDiet.vue')
const MediterraneanDietHdlFunction = () => import('@/views/Research/MediterraneanDietHdlFunction.vue')
const FirefighterHealth = () => import('@/views/Research/FirefighterHealth.vue')
const MediterraneanDietResearch = () => import('@/views/Research/MediterraneanDietResearch.vue')
const MayoClinicMediterraneanDiet = () => import('@/views/Research/MayoClinicMediterraneanDiet.vue')
const SugarEffectsResearch = () => import('@/views/Research/SugarEffectsResearch.vue')
const SuperTracker = () => import('@/views/Nutrition/SuperTracker.vue')
const TeachingAmericasBravest = () => import('@/views/Nutrition/TeachingAmericasBravest.vue')
const DavidLudwigInterview = () => import('@/views/Research/DavidLudwigInterview.vue')
const SkordaliRecipe = () => import('@/views/Recipes/SkordaliRecipe.vue')
const PuertoRicanHeartHealth = () => import('@/views/Research/PuertoRicanHeartHealth.vue')
const OreganoGarlicVinaigrette = () => import('@/views/Recipes/OreganoGarlicVinaigrette.vue')
const SugaryDrinks = () => import('@/views/Health/SugaryDrinks.vue')
const GuacamoleRecipe = () => import('@/views/Recipes/GuacamoleRecipe.vue')
const HummusRecipe = () => import('@/views/Recipes/HummusRecipe.vue')
const ChiliVinaigretteRecipe = () => import('@/views/Recipes/ChiliVinaigretteRecipe.vue')
const MintVinaigretteRecipe = () => import('@/views/Recipes/MintVinaigretteRecipe.vue')
const WalnutPestoRecipe = () => import('@/views/Recipes/WalnutPestoRecipe.vue')
const ItalianTrapaneseRecipe = () => import('@/views/Recipes/ItalianTrapaneseRecipe.vue')
const HerbedOliveLentilSpreadRecipe = () => import('@/views/Recipes/HerbedOliveLentilSpreadRecipe.vue')
const SpanishRomescoRecipe = () => import('@/views/Recipes/SpanishRomescoRecipe.vue')
const TurkishMuhammaraRecipe = () => import('@/views/Recipes/TurkishMuhammaraRecipe.vue')
const TurkishTaratorRecipe = () => import('@/views/Recipes/TurkishTaratorRecipe.vue')
const WhiteBeanKaleSpreadRecipe = () => import('@/views/Recipes/WhiteBeanKaleSpreadRecipe.vue')
const FishTacosRecipe = () => import('@/views/OldwaysRecipes/FishTacosRecipe.vue')
const MexicanBeanDipRecipe = () => import('@/views/OldwaysRecipes/MexicanBeanDipRecipe.vue')
const SweetPotatoToastsRecipe = () => import('@/views/OldwaysRecipes/SweetPotatoToastsRecipe.vue')
const PeanutSikilPakRecipe = () => import('@/views/OldwaysRecipes/PeanutSikilPakRecipe.vue')
const SpicyStirFriedGreensRecipe = () => import('@/views/OldwaysRecipes/SpicyStirFriedGreensRecipe.vue')
const FigOrangeVinaigretteRecipe = () => import('@/views/OldwaysRecipes/FigOrangeVinaigretteRecipe.vue')
const AlFrescoSunDriedTomatoPastaRecipe = () => import('@/views/OldwaysRecipes/AlFrescoSunDriedTomatoPastaRecipe.vue')
const CucumberTomatoPeanutSaladRecipe = () => import('@/views/OldwaysRecipes/CucumberTomatoPeanutSaladRecipe.vue')
const EasyCampanellePancettaRecipe = () => import('@/views/OldwaysRecipes/EasyCampanellePancettaRecipe.vue')
const ShellsCherryTomatoesRecipe = () => import('@/views/OldwaysRecipes/ShellsCherryTomatoesRecipe.vue')
const MarinatedMushroomsFavaBeetsPitaRecipe = () => import('@/views/OldwaysRecipes/MarinatedMushroomsFavaBeetsPitaRecipe.vue')

// 其他頁面
const About = () => import('@/views/About.vue')
const Contact = () => import('@/views/Contact.vue')
const Privacy = () => import('@/views/Privacy.vue')
const Terms = () => import('@/views/Terms.vue')
const Search = () => import('@/views/Search.vue')

// 路由定義
const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '首頁',
      description: '消防員地中海飲食指南 - 專為消防員設計的健康飲食指南',
    },
  },
  
  // Express風格的簡潔版本
  {
    path: '/express',
    name: 'HomeExpress',
    component: () => import('@/views/HomeExpress.vue'),
    meta: {
      title: '消防員地中海飲食指南 - Express風格',
      description: '完全模仿Express版本UX的簡潔設計',
    },
  },
  
  // 營養指南路由
  {
    path: '/nutrition',
    name: 'Nutrition',
    component: NutritionIndex,
    meta: {
      title: '營養指南',
      description: '專業的營養建議和飲食指南',
    },
    children: [
      {
        path: 'mediterranean-diet-guide',
        name: 'MediterraneanDietGuide',
        component: MediterraneanDietGuide,
        meta: {
          title: '地中海飲食指南',
          description: '了解地中海飲食的基本原則和健康益處',
        },
      },
      {
        path: 'healthy-fats-recipes',
        name: 'HealthyFatsRecipes',
        component: HealthyFatsRecipes,
        meta: {
          title: '健康油脂食譜',
          description: '富含健康油脂的美味食譜',
        },
      },
      {
        path: 'supertracker',
        name: 'SuperTracker',
        component: SuperTracker,
        meta: {
          title: 'SuperTracker 飲食追蹤工具',
          description: '美國農業部 SuperTracker 飲食規劃與追蹤工具達百萬用戶',
        },
      },
      {
        path: 'teaching-americas-bravest',
        name: 'TeachingAmericasBravest',
        component: TeachingAmericasBravest,
        meta: {
          title: '教育美國最勇敢的消防員',
          description: '哈佛教授鼓勵美國消防員轉向地中海飲食，避免值勤期間心臟病發作',
        },
      },
    ],
  },
  
  // 食譜路由
  {
    path: '/recipes',
    name: 'Recipes',
    component: RecipesIndex,
    meta: {
      title: '食譜',
      description: '健康美味的地中海飲食食譜',
    },
    children: [
      {
        path: 'main',
        name: 'MainRecipes',
        component: MainRecipes,
        meta: {
          title: '主要食譜',
          description: '精選的主菜和配菜食譜',
        },
      },
      {
        path: 'oldways',
        name: 'OldwaysRecipes',
        component: OldwaysRecipes,
        meta: {
          title: 'Oldways 食譜',
          description: '傳統的地中海飲食食譜',
        },
      },
      {
        path: 'skordali',
        name: 'SkordaliRecipe',
        component: SkordaliRecipe,
        meta: {
          title: '希臘蒜泥醬（Skordalia）',
          description: '經典希臘蒜泥醬食譜，杏仁、麵包和大蒜的完美組合',
        },
      },
      {
        path: 'oregano-garlic-vinaigrette',
        name: 'OreganoGarlicVinaigrette',
        component: OreganoGarlicVinaigrette,
        meta: {
          title: '奧勒岡大蒜油醋醬',
          description: '經典地中海風味醬料，完美搭配沙拉和烤蔬菜',
        },
      },
      {
        path: 'guacamole',
        name: 'GuacamoleRecipe',
        component: GuacamoleRecipe,
        meta: {
          title: '酪梨醬（Guacamole）',
          description: '墨西哥傳統醬料，富含健康脂肪和維生素',
        },
      },
      {
        path: 'hummus',
        name: 'HummusRecipe',
        component: HummusRecipe,
        meta: {
          title: '鷹嘴豆泥（Hummus）',
          description: '經典地中海豆類抹醬，富含蛋白質和纖維',
        },
      },
      {
        path: 'chili-vinaigrette',
        name: 'ChiliVinaigretteRecipe',
        component: ChiliVinaigretteRecipe,
        meta: {
          title: '辣椒油醋醬',
          description: '辣味醬料，增添料理層次豐富的風味',
        },
      },
      {
        path: 'mint-vinaigrette',
        name: 'MintVinaigretteRecipe',
        component: MintVinaigretteRecipe,
        meta: {
          title: '薄荷油醋醬',
          description: '清新的薄荷醬料，適合搭配多種沙拉和蔬菜',
        },
      },
      {
        path: 'walnut-pesto',
        name: 'WalnutPestoRecipe',
        component: WalnutPestoRecipe,
        meta: {
          title: '核桃青醬',
          description: '使用核桃取代松子的青醬，香氣濃郁口感豐富',
        },
      },
      {
        path: 'italian-trapanese',
        name: 'ItalianTrapaneseRecipe',
        component: ItalianTrapaneseRecipe,
        meta: {
          title: '義大利特拉帕尼青醬',
          description: '特拉帕尼式青醬，杏仁、荷蘭芹、羅勒和番茄的完美組合',
        },
      },
      {
        path: 'herbed-olive-lentil-spread',
        name: 'HerbedOliveLentilSpreadRecipe',
        component: HerbedOliveLentilSpreadRecipe,
        meta: {
          title: '香草橄欖綠扁豆泥',
          description: '健康營養的綠扁豆泥，搭配新鮮香草和橄欖',
        },
      },
      {
        path: 'spanish-romesco',
        name: 'SpanishRomescoRecipe',
        component: SpanishRomescoRecipe,
        meta: {
          title: '西班牙羅梅斯科醬',
          description: '經典西班牙醬料，紅椒杏仁的完美組合',
        },
      },
      {
        path: 'turkish-muhammara',
        name: 'TurkishMuhammaraRecipe',
        component: TurkishMuhammaraRecipe,
        meta: {
          title: '土耳其穆罕默拉醬',
          description: '中東風味的紅椒核桃醬，富含抗氧化物和健康脂肪',
        },
      },
      {
        path: 'turkish-tarator',
        name: 'TurkishTaratorRecipe',
        component: TurkishTaratorRecipe,
        meta: {
          title: '土耳其塔拉托爾醬',
          description: '傳統的核桃大蒜醬，可選擇加入芝麻醬調味',
        },
      },
      {
        path: 'white-bean-kale-spread',
        name: 'WhiteBeanKaleSpreadRecipe',
        component: WhiteBeanKaleSpreadRecipe,
        meta: {
          title: '白豆羽衣甘藍泥',
          description: '營養豐富的白豆羽衣甘藍泥，富含蛋白質和纖維',
        },
      },
      {
        path: 'fish-tacos',
        name: 'FishTacosRecipe',
        component: FishTacosRecipe,
        meta: {
          title: '魚肉玉米餅',
          description: '健康美味的墨西哥風味魚肉玉米餅',
        },
      },
      {
        path: 'mexican-bean-dip',
        name: 'MexicanBeanDipRecipe',
        component: MexicanBeanDipRecipe,
        meta: {
          title: '墨西哥豆醬',
          description: '營養豐富的墨西哥黑豆醬，適合作為健康零食',
        },
      },
      {
        path: 'sweet-potato-toasts',
        name: 'SweetPotatoToastsRecipe',
        component: SweetPotatoToastsRecipe,
        meta: {
          title: '地瓜吐司',
          description: '創意健康的地瓜吐司，可搭配多種營養配料',
        },
      },
      {
        path: 'peanut-sikil-pak',
        name: 'PeanutSikilPakRecipe',
        component: PeanutSikilPakRecipe,
        meta: {
          title: '花生 Sikil P\'ak',
          description: '墨西哥尤卡坦半島傳統醬料，富含蛋白質和健康脂肪',
        },
      },
      {
        path: 'spicy-stir-fried-greens',
        name: 'SpicyStirFriedGreensRecipe',
        component: SpicyStirFriedGreensRecipe,
        meta: {
          title: '辣炒青菜配花生',
          description: '健康蔬菜主菜，富含鐵質和植物蛋白',
        },
      },
      {
        path: 'fig-orange-vinaigrette',
        name: 'FigOrangeVinaigretteRecipe',
        component: FigOrangeVinaigretteRecipe,
        meta: {
          title: '無花果橙醋汁',
          description: '水果醋汁醬料，結合無花果甜味和柑橘清新',
        },
      },
      {
        path: 'al-fresco-sun-dried-tomato-pasta',
        name: 'AlFrescoSunDriedTomatoPastaRecipe',
        component: AlFrescoSunDriedTomatoPastaRecipe,
        meta: {
          title: '戶外風乾番茄義大利麵沙拉',
          description: '地中海義式沙拉，適合野餐或戶外聚會',
        },
      },
      {
        path: 'cucumber-tomato-peanut-salad',
        name: 'CucumberTomatoPeanutSaladRecipe',
        component: CucumberTomatoPeanutSaladRecipe,
        meta: {
          title: '黃瓜番茄沙拉配花生醋汁',
          description: '清爽蔬菜沙拉，東西方料理融合的絕佳例子',
        },
      },
      {
        path: 'easy-campanelle-pancetta',
        name: 'EasyCampanellePancettaRecipe',
        component: EasyCampanellePancettaRecipe,
        meta: {
          title: '簡易鐘形麵配青菜和義大利培根',
          description: '義式主菜，結合全麥鐘形麵、瑞士甜菜、義大利培根',
        },
      },
      {
        path: 'shells-cherry-tomatoes',
        name: 'ShellsCherryTomatoesRecipe',
        component: ShellsCherryTomatoesRecipe,
        meta: {
          title: '貝殼麵配櫻桃番茄、羅勒和帕瑪森起司',
          description: '經典義式料理，展現新鮮食材的美味',
        },
      },
      {
        path: 'marinated-mushrooms-fava-beets-pita',
        name: 'MarinatedMushroomsFavaBeetsPitaRecipe',
        component: MarinatedMushroomsFavaBeetsPitaRecipe,
        meta: {
          title: '醃蘑菇、蠶豆、甜菜和菲達起司配全穀皮塔餅',
          description: '地中海蔬食料理，營養均衡且色彩豐富',
        },
      },
      {
        path: ':id',
        name: 'RecipeDetail',
        component: RecipeDetail,
        meta: {
          title: '食譜詳情',
          description: '詳細的食譜製作步驟和營養資訊',
        },
        props: true,
      },
    ],
  },
  
  // 健康資訊路由
  {
    path: '/health',
    name: 'Health',
    component: HealthIndex,
    meta: {
      title: '健康資訊',
      description: '消防員專用的健康資訊和建議',
    },
    children: [
      {
        path: 'sleep',
        name: 'Sleep',
        component: Sleep,
        meta: {
          title: '睡眠健康',
          description: '改善睡眠品質的建議和技巧',
        },
      },
      {
        path: 'sleep-survey',
        name: 'SleepSurvey',
        component: SleepSurvey,
        meta: {
          title: '睡眠問卷',
          description: '評估您的睡眠品質',
        },
      },
      {
        path: 'healthy-meetings',
        name: 'HealthyMeetings',
        component: HealthyMeetings,
        meta: {
          title: '健康會議',
          description: '促進團隊健康的會議指南',
        },
      },
      {
        path: 'sugary-drinks',
        name: 'SugaryDrinks',
        component: SugaryDrinks,
        meta: {
          title: '含糖飲料',
          description: '了解含糖飲料對健康的影響及如何做出更好的選擇',
        },
      },
      {
        path: 'stopp',
        name: 'STOPP',
        component: STOPP,
        meta: {
          title: 'STOPP 方法',
          description: '壓力管理和情緒調節技巧',
        },
      },
    ],
  },
  
  // 研究文章路由
  {
    path: '/research',
    name: 'Research',
    component: ResearchIndex,
    meta: {
      title: '研究文章',
      description: '最新的科學研究和醫學發現',
    },
    children: [
      {
        path: 'harvard',
        name: 'HarvardStudies',
        component: HarvardStudies,
        meta: {
          title: '哈佛研究',
          description: '哈佛大學相關的健康研究',
        },
      },
      {
        path: 'firefighter-health',
        name: 'FirefighterHealthResearch',
        component: FirefighterHealth,
        meta: {
          title: '消防員健康研究',
          description: '專門針對消防員的健康研究',
        },
      },
      {
        path: 'mediterranean-diet',
        name: 'MediterraneanDietResearch',
        component: MediterraneanDietResearch,
        meta: {
          title: '地中海飲食研究',
          description: '地中海飲食的科學研究證據',
        },
      },
      {
        path: 'mayo-clinic-mediterranean-diet',
        name: 'MayoClinicMediterraneanDiet',
        component: MayoClinicMediterraneanDiet,
        meta: {
          title: 'Mayo Clinic 地中海飲食',
          description: 'Mayo Clinic 關於地中海飲食與心臟健康的專業指南',
        },
      },
      {
        path: 'sugar-effects',
        name: 'SugarEffectsResearch',
        component: SugarEffectsResearch,
        meta: {
          title: '糖類影響健康研究',
          description: '哈佛研究探討糖對人體和公共政策的影響',
        },
      },
      {
        path: 'david-ludwig-interview',
        name: 'DavidLudwigInterview',
        component: DavidLudwigInterview,
        meta: {
          title: '即席訪談：David S. Ludwig',
          description: '哈佛公共衛生學院營養系教授關於減重和健康飲食的專業建議',
        },
      },
      {
        path: 'puerto-rican-heart-health',
        name: 'PuertoRicanHeartHealth',
        component: PuertoRicanHeartHealth,
        meta: {
          title: '波多黎各成人透過地中海飲食提升心血管健康',
          description: '哈佛研究顯示地中海飲食對波多黎各成年人心血管健康的積極影響',
        },
      },
    ],
  },
  
  // 直接路由頁面 (對應原網站結構)
  {
    path: '/healthy-living-guide',
    name: 'HealthyLivingGuideDirect',
    component: () => import('@/views/HealthyLivingGuide.vue'),
    meta: {
      title: '2023/2024 健康生活指南',
      description: '正念飲食、健康餐點製作藍圖、睡眠資訊等完整健康生活建議'
    }
  },
  {
    path: '/sleep',
    name: 'SleepDirect',
    component: () => import('@/views/Health/Sleep.vue'),
    meta: {
      title: '睡眠健康指南',
      description: '了解睡眠的重要性、睡眠週期以及改善睡眠品質的建議'
    }
  },

  // 食譜直接路由 (對應原網站的 /recipes/ 路徑)
  {
    path: '/hummus',
    name: 'HummusRecipeDirect',
    component: () => import('@/views/Recipes/HummusRecipe.vue'),
    meta: {
      title: '鷹嘴豆泥（Hummus）',
      description: '經典的地中海鷹嘴豆泥食譜，富含蛋白質和纖維'
    }
  },
  {
    path: '/guacamole',
    name: 'GuacamoleRecipeDirect',
    component: () => import('@/views/Recipes/GuacamoleRecipe.vue'),
    meta: {
      title: '酪梨醬（Guacamole）',
      description: '營養豐富的酪梨醬食譜'
    }
  },
  {
    path: '/chili-vinaigrette',
    name: 'ChiliVinaigretteRecipeDirect',
    component: () => import('@/views/Recipes/ChiliVinaigretteRecipe.vue'),
    meta: {
      title: '辣椒油醋醬',
      description: '辣味醬料，增添料理層次豐富的風味'
    }
  },
  {
    path: '/herbed-olive-lentil-spread',
    name: 'HerbedOliveLentilSpreadRecipeDirect',
    component: () => import('@/views/Recipes/HerbedOliveLentilSpreadRecipe.vue'),
    meta: {
      title: '香草橄欖綠扁豆泥',
      description: '健康營養的綠扁豆泥，搭配新鮮香草和橄欖'
    }
  },
  {
    path: '/italian-trapanese-pesto',
    name: 'ItalianTrapaneseRecipeDirect',
    component: () => import('@/views/Recipes/ItalianTrapaneseRecipe.vue'),
    meta: {
      title: '義大利特拉帕尼青醬',
      description: '特拉帕尼式青醬，杏仁、荷蘭芹、羅勒和番茄的完美組合'
    }
  },
  {
    path: '/mint-vinaigrette',
    name: 'MintVinaigretteRecipeDirect',
    component: () => import('@/views/Recipes/MintVinaigretteRecipe.vue'),
    meta: {
      title: '薄荷油醋醬',
      description: '清新的薄荷醬料，適合搭配多種沙拉和蔬菜'
    }
  },
  {
    path: '/oregano-garlic-vinaigrette',
    name: 'OreganoGarlicVinaigretteDirect',
    component: () => import('@/views/Recipes/OreganoGarlicVinaigrette.vue'),
    meta: {
      title: '奧勒岡大蒜油醋醬',
      description: '經典地中海風味醬料，完美搭配沙拉和烤蔬菜'
    }
  },
  {
    path: '/skordalia',
    name: 'SkordaliRecipeDirect',
    component: () => import('@/views/Recipes/SkordaliRecipe.vue'),
    meta: {
      title: '希臘蒜泥醬（Skordalia）',
      description: '經典希臘蒜泥醬食譜，杏仁、麵包和大蒜的完美組合'
    }
  },
  {
    path: '/spanish-romesco-sauce',
    name: 'SpanishRomescoRecipeDirect',
    component: () => import('@/views/Recipes/SpanishRomescoRecipe.vue'),
    meta: {
      title: '西班牙羅梅斯科醬',
      description: '經典西班牙醬料，紅椒杏仁的完美組合'
    }
  },
  {
    path: '/turkish-muhammara',
    name: 'TurkishMuhammaraRecipeDirect',
    component: () => import('@/views/Recipes/TurkishMuhammaraRecipe.vue'),
    meta: {
      title: '土耳其穆罕默拉醬',
      description: '中東風味的紅椒核桃醬，富含抗氧化物和健康脂肪'
    }
  },
  {
    path: '/turkish-tarator-sauce',
    name: 'TurkishTaratorRecipeDirect',
    component: () => import('@/views/Recipes/TurkishTaratorRecipe.vue'),
    meta: {
      title: '土耳其塔拉托爾醬',
      description: '傳統的核桃大蒜醬，可選擇加入芝麻醬調味'
    }
  },
  {
    path: '/walnut-pesto',
    name: 'WalnutPestoRecipeDirect',
    component: () => import('@/views/Recipes/WalnutPestoRecipe.vue'),
    meta: {
      title: '核桃青醬',
      description: '使用核桃取代松子的青醬，香氣濃郁口感豐富'
    }
  },
  {
    path: '/white-bean-kale-spread',
    name: 'WhiteBeanKaleSpreadRecipeDirect',
    component: () => import('@/views/Recipes/WhiteBeanKaleSpreadRecipe.vue'),
    meta: {
      title: '白豆羽衣甘藍泥',
      description: '營養豐富的白豆羽衣甘藍泥，富含蛋白質和纖維'
    }
  },
  {
    path: '/healthy-fats-recipes',
    name: 'HealthyFatsRecipesDirect',
    component: () => import('@/views/HealthyFatsRecipes.vue'),
    meta: {
      title: '健康脂肪食譜',
      description: '富含健康脂肪的地中海飲食食譜集合'
    }
  },

  // Oldways 食譜直接路由 (對應原網站的 /oldways_recipes/ 路徑)
  {
    path: '/oldways_recipes/spicy_stir_fried_greens_peanuts_zh',
    name: 'SpicyStirFriedGreensRecipeDirect',
    component: () => import('@/views/OldwaysRecipes/SpicyStirFriedGreensRecipe.vue'),
    meta: {
      title: '辣炒青菜配花生',
      description: '健康蔬菜主菜，富含鐵質和植物蛋白'
    }
  },
  {
    path: '/oldways_recipes/migas_con_huevos_zh',
    name: 'MigasConHuevosRecipeDirect',
    component: () => import('@/views/OldwaysRecipes/MigasConHuevosRecipe.vue'),
    meta: {
      title: 'Migas Con Huevos（墨西哥炒蛋）',
      description: '傳統墨西哥早餐，營養豐富的炒蛋料理'
    }
  },
  {
    path: '/oldways_recipes/mexican_bean_dip_zh',
    name: 'MexicanBeanDipRecipeDirect',
    component: () => import('@/views/OldwaysRecipes/MexicanBeanDipRecipe.vue'),
    meta: {
      title: '墨西哥豆醬',
      description: '營養豐富的墨西哥黑豆醬，適合作為健康零食'
    }
  },
  {
    path: '/oldways_recipes/peanut_sikil_pak_zh',
    name: 'PeanutSikilPakRecipeDirect',
    component: () => import('@/views/OldwaysRecipes/PeanutSikilPakRecipe.vue'),
    meta: {
      title: '花生 Sikil P\'ak',
      description: '墨西哥尤卡坦半島傳統醬料，富含蛋白質和健康脂肪'
    }
  },
  {
    path: '/oldways_recipes/fig_orange_vinaigrette_zh',
    name: 'FigOrangeVinaigretteRecipeDirect',
    component: () => import('@/views/OldwaysRecipes/FigOrangeVinaigretteRecipe.vue'),
    meta: {
      title: '無花果橙醋汁',
      description: '水果醋汁醬料，結合無花果甜味和柑橘清新'
    }
  },
  {
    path: '/oldways_recipes/al_fresco_sun_dried_tomato_pasta_salad_zh',
    name: 'AlFrescoSunDriedTomatoPastaRecipeDirect',
    component: () => import('@/views/OldwaysRecipes/AlFrescoSunDriedTomatoPastaRecipe.vue'),
    meta: {
      title: '戶外風乾番茄義大利麵沙拉',
      description: '地中海義式沙拉，適合野餐或戶外聚會'
    }
  },
  {
    path: '/oldways_recipes/shells_cherry_tomatoes_basil_parmigiano_reggiano_zh',
    name: 'ShellsCherryTomatoesRecipeDirect',
    component: () => import('@/views/OldwaysRecipes/ShellsCherryTomatoesRecipe.vue'),
    meta: {
      title: '貝殼麵配櫻桃番茄、羅勒和帕瑪森起司',
      description: '經典義式料理，展現新鮮食材的美味'
    }
  },
  {
    path: '/oldways_recipes/marinated_mushrooms_fava_beans_beets_feta_whole_grain_pita_zh',
    name: 'MarinatedMushroomsFavaBeetsPitaRecipeDirect',
    component: () => import('@/views/OldwaysRecipes/MarinatedMushroomsFavaBeetsPitaRecipe.vue'),
    meta: {
      title: '醃蘑菇、蠶豆、甜菜和菲達起司配全穀皮塔餅',
      description: '地中海蔬食料理，營養均衡且色彩豐富'
    }
  },
  {
    path: '/oldways_recipes/cucumber_tomato_salad_peanut_vinaigrette_zh',
    name: 'CucumberTomatoPeanutSaladRecipeDirect',
    component: () => import('@/views/OldwaysRecipes/CucumberTomatoPeanutSaladRecipe.vue'),
    meta: {
      title: '黃瓜番茄沙拉配花生醋汁',
      description: '清爽蔬菜沙拉，東西方料理融合的絕佳例子'
    }
  },
  {
    path: '/oldways_recipes/sweet_potato_toasts_zh',
    name: 'SweetPotatoToastsRecipeDirect',
    component: () => import('@/views/OldwaysRecipes/SweetPotatoToastsRecipe.vue'),
    meta: {
      title: '地瓜吐司',
      description: '創意健康的地瓜吐司，可搭配多種營養配料'
    }
  },
  {
    path: '/oldways_recipes/easy_campanelle_greens_pancetta_zh',
    name: 'EasyCampanellePancettaRecipeDirect',
    component: () => import('@/views/OldwaysRecipes/EasyCampanellePancettaRecipe.vue'),
    meta: {
      title: '簡易鐘形麵配青菜和義大利培根',
      description: '義式主菜，結合全麥鐘形麵、瑞士甜菜、義大利培根'
    }
  },
  {
    path: '/oldways_recipes/fish_tacos_zh',
    name: 'FishTacosRecipeDirect',
    component: () => import('@/views/OldwaysRecipes/FishTacosRecipe.vue'),
    meta: {
      title: '魚肉玉米餅',
      description: '健康美味的墨西哥風味魚肉玉米餅'
    }
  },

  // 哈佛研究文章直接路由
  {
    path: '/harvard_firefighters_mediterranean_diet_zh',
    name: 'HarvardFirefightersMediterraneanDiet',
    component: () => import('@/views/HarvardFirefightersMediterraneanDiet.vue'),
    meta: {
      title: '地中海飲食與職場健康',
      description: '哈佛公共衛生學院關於地中海飲食與職場健康的研究會議'
    }
  },
  {
    path: '/harvard_firehouse_cancer_threat_zh',
    name: 'HarvardFirehouseCancerThreat',
    component: () => import('@/views/HarvardFirehouseCancerThreat.vue'),
    meta: {
      title: '消防隊的癌症風險問題',
      description: '哈佛研究調查消防隊環境如何增加消防員的癌症風險'
    }
  },
  {
    path: '/firefighter_functional_fitness_zh',
    name: 'FirefighterFunctionalFitness',
    component: () => import('@/views/FirefighterFunctionalFitness.vue'),
    meta: {
      title: '消防員功能性體適能',
      description: '專為消防員設計的功能性體適能指南，提高工作表現、預防傷害、延長職業生涯的重要知識和工具'
    }  
  },
  {
    path: '/sugary-drinks',
    name: 'SugaryDrinksDirect',
    component: () => import('@/views/Health/SugaryDrinks.vue'),
    meta: {
      title: '含糖飲料對健康的影響',
      description: '了解含糖飲料對健康的影響及如何做出更好的選擇'
    }
  },
  {
    path: '/stopp',
    name: 'STOPPDirect',
    component: () => import('@/views/Health/STOPP.vue'),
    meta: {
      title: 'STOPP 壓力管理方法',
      description: '學習有效的壓力管理和情緒調節技巧'
    }
  },
  {
    path: '/sleep-survey',
    name: 'SleepSurveyDirect',
    component: () => import('@/views/Health/SleepSurvey.vue'),
    meta: {
      title: '睡眠健康評估問卷',
      description: '透過專業問卷評估您的睡眠品質'
    }
  },
  {
    path: '/oldways_recipes_zh',
    name: 'OldwaysRecipesDirect',
    component: () => import('@/views/Recipes/OldwaysRecipes.vue'),
    meta: {
      title: 'Oldways 傳統地中海飲食食譜',
      description: '來自 Oldways 組織的傳統地中海飲食食譜集合'
    }
  },
  {
    path: '/supertracker_zh',
    name: 'SuperTrackerDirect',
    component: () => import('@/views/Nutrition/SuperTracker.vue'),
    meta: {
      title: 'USDA SuperTracker 飲食追蹤工具',
      description: '美國農業部 SuperTracker 飲食規劃與追蹤工具'
    }
  },
  {
    path: '/mediterranean_diet_guide_zh',
    name: 'MediterraneanDietGuideDirect',
    component: () => import('@/views/Nutrition/MediterraneanDietGuide.vue'),
    meta: {
      title: '地中海飲食完整指南',
      description: '全面了解地中海飲食的原則、益處和實踐方法'
    }
  },
  {
    path: '/david_ludwig_interview_zh',
    name: 'DavidLudwigInterviewDirect',
    component: () => import('@/views/Research/DavidLudwigInterview.vue'),
    meta: {
      title: '即席訪談：David S. Ludwig 博士',
      description: '哈佛公共衛生學院營養系教授關於減重和健康飲食的專業建議'
    }
  },
  {
    path: '/mayo_clinic_mediterranean_diet_zh',
    name: 'MayoClinicMediterraneanDietDirect',
    component: () => import('@/views/Research/MayoClinicMediterraneanDiet.vue'),
    meta: {
      title: 'Mayo Clinic：地中海飲食與心臟健康',
      description: 'Mayo Clinic 關於地中海飲食對心血管健康益處的專業指南'
    }
  },
  {
    path: '/healthy_meetings_zh',
    name: 'HealthyMeetingsDirect',
    component: () => import('@/views/Health/HealthyMeetings.vue'),
    meta: {
      title: '舉辦健康會議指南',
      description: '學習如何規劃和舉辦促進團隊健康的會議'
    }
  },
  {
    path: '/sugar_effects_zh',
    name: 'SugarEffectsResearchDirect',
    component: () => import('@/views/Research/SugarEffectsResearch.vue'),
    meta: {
      title: '探討糖對人體和公共政策的影響',
      description: '哈佛研究會議探討甜味劑對人體健康和公共政策的影響'
    }
  },
  {
    path: '/teaching_americas_bravest_med_style_survival_zh',
    name: 'TeachingAmericasBravestDirect',
    component: () => import('@/views/Nutrition/TeachingAmericasBravest.vue'),
    meta: {
      title: '教育美國最勇敢的消防員：地中海生存方式',
      description: '哈佛教授鼓勵美國消防員轉向地中海飲食，預防值勤期間心臟病發作'
    }
  },
  {
    path: '/harvard_diet_quality_premature_death_zh',
    name: 'HarvardDietQualityPrematureDeathDirect',
    component: HarvardDietQuality,
    meta: {
      title: '改善飲食品質與降低早逝風險的關聯',
      description: '哈佛研究顯示改善飲食品質可顯著降低早逝風險'
    }
  },
  {
    path: '/hdl_function_improved_mediterranean_diet_zh',
    name: 'HDLFunctionImprovedMediterraneanDietDirect',
    component: HdlFunctionMedDiet,
    meta: {
      title: 'PREDIMED 研究：地中海飲食改善 HDL 功能',
      description: '研究顯示富含橄欖油的地中海飲食如何改善高密度脂蛋白功能'
    }
  },
  {
    path: '/mediterranean_diet_puerto_rican_heart_health_zh',
    name: 'MediterraneanDietPuertoRicanHeartHealthDirect',
    component: () => import('@/views/Research/PuertoRicanHeartHealth.vue'),
    meta: {
      title: '波多黎各成人透過地中海飲食提升心血管健康',
      description: '研究顯示地中海飲食對波多黎各成年人心血管健康的積極影響'
    }
  },
  {
    path: '/mediterranean_diet_hdl_function_zh',
    name: 'MediterraneanDietHDLFunctionDirect',
    component: MediterraneanDietHdlFunction,
    meta: {
      title: '消防與心臟：預防的意義',
      description: '探討消防員心血管疾病流行病學與預防策略'
    }
  },

  // 其他頁面
  {
    path: '/about',
    name: 'About',
    component: About,
    meta: {
      title: '關於我們',
      description: '了解 FireHealth 的使命和團隊',
    },
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact,
    meta: {
      title: '聯絡我們',
      description: '與我們取得聯繫',
    },
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: Privacy,
    meta: {
      title: '隱私政策',
      description: '我們的隱私保護政策',
    },
  },
  {
    path: '/terms',
    name: 'Terms',
    component: Terms,
    meta: {
      title: '使用條款',
      description: '網站使用條款和條件',
    },
  },
  {
    path: '/search',
    name: 'Search',
    component: Search,
    meta: {
      title: '搜尋結果',
      description: '搜尋結果頁面',
    },
  },
  
  // 404 頁面
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound,
    meta: {
      title: '頁面不存在',
      description: '您所訪問的頁面不存在',
    },
  },
]

// 創建路由器
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的位置 (瀏覽器前進/後退)
    if (savedPosition) {
      return savedPosition
    }
    
    // 如果有錨點，滾動到錨點
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      }
    }
    
    // 否則滾動到頂部
    return { top: 0 }
  },
})

// 全域前置守衛
router.beforeEach((to, from, next) => {
  // 設置頁面標題
  const title = to.meta?.title
  if (title) {
    document.title = `${title} | FireHealth - 消防員地中海飲食指南`
  } else {
    document.title = 'FireHealth - 消防員地中海飲食指南'
  }
  
  // 設置頁面描述
  const description = to.meta?.description as string
  if (description) {
    const metaDescription = document.querySelector('meta[name="description"]')
    if (metaDescription) {
      metaDescription.setAttribute('content', description)
    }
  }
  
  next()
})

// 全域後置守衛
router.afterEach((to, from) => {
  // 可以在這裡添加分析追蹤
  if (typeof window !== 'undefined' && 'gtag' in window) {
    const gtag = (window as any).gtag
    gtag('config', 'GA_MEASUREMENT_ID', {
      page_title: to.meta?.title || '',
      page_location: to.fullPath,
    })
  }
})

export default router
